import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Bag: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--bag')}
    data-icon={icon}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="21"
    viewBox="0 0 16 21"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M-10-11h408v66H-10z" />
      <g fill="#000" fillRule="nonzero">
        <path d="M12.165 5.763c-.104-.967-.274-2.086-.64-3.073C10.87.91 9.753 0 8.21 0h-.01c-1.54 0-2.654.903-3.315 2.686-.365.99-.538 2.112-.64 3.08H.714L0 21h7.336a6.496 6.496 0 0 1 1.184-7.466A6.59 6.59 0 0 1 16 12.19l-.3-6.427h-3.535zm-7.697 2.36a.8.8 0 1 1-.29-1.55l-.026.335-.03.385a.344.344 0 0 0 .148.313.35.35 0 0 0 .544-.256l.03-.39.027-.332a.8.8 0 0 1-.402 1.496zm.482-2.36c.097-.91.26-1.947.592-2.842.552-1.5 1.42-2.23 2.656-2.23h.01c1.24 0 2.113.737 2.67 2.24.33.892.493 1.925.59 2.834H4.95zm6.998 2.36a.8.8 0 1 1-.403-1.494l.026.334.03.387c.016.18.167.32.348.318h.03a.348.348 0 0 0 .317-.373l-.03-.383-.026-.336a.8.8 0 0 1-.29 1.55v-.002z" />
        <path d="M13.116 18.677c.25-.253.355.046.355.046L14.43 21h.93l-1.072-2.633s-.136-.285.215-.294l1.5-.006L12 14l.08 5.77 1.036-1.093z" />
      </g>
    </g>
  </svg>
);

export default Bag;
